/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HTTPValidationError } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class DownloadDocument<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @description Endpoint para descargar el documento en formato Word.
   *
   * @tags documents
   * @name DownloadDocumentDownloadDocumentPost
   * @summary Download Document
   * @request POST:/download-document
   */
  downloadDocumentDownloadDocumentPost = (data: Record<string, any>, params: RequestParams = {}) =>
    this.request<any, HTTPValidationError>({
      path: `/download-document`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
